const isNumber = (value) => typeof value === "number";
export {
  isNumber as i
};
//# sourceMappingURL=is-number.js.map
